import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getData } from '../../../utils/fetch';

export const getDataEvent = createAsyncThunk("event/getData", async (args, { rejectWithValue }) => {
    try {
        const result = await getData(`/cms/events`);
        return result.data.data;
    } catch (error) {
        rejectWithValue(error.response.data);
    }
})

const eventSlice = createSlice({
    name: "event",
    initialState: {
        data: [],
        page: 1,
        limit: 10,
        status: 'idle',
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getDataEvent.pending, (state, action) => {
            state.status = 'loading';
        })
            .addCase(getDataEvent.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(getDataEvent.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
    }
});

export default eventSlice.reducer;